import Vue from 'vue' 
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'
import Inputmask from "inputmask";

import Home from './../vue/Home'

$("document").ready(function() {



  if ($('.aos').length > 0) {
    AOS.init();
  }

  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        $('.header').addClass('scrolling');
    } else {
        $('.header').removeClass('scrolling');
    }

    
});

  $('.menu-toggle').on('click',function(e){
    $('.menu-toggle').toggleClass('active');    
    $('.header .logo').toggleClass('active');    
    $('.header .logoalt').toggleClass('active');    
    $('.mainMenu').toggleClass('active');    
    $('.mainMenu').slideToggle();
    e.preventDefault();
  });
  
  if($('.menu-item-has-children').length > 0){
    $('.menu-item-has-children > a').append('<span class="toggle"></span>');
    $('.toggle').click(function(e) {
      $(this).parent().parent().toggleClass('active');
      $(this).parent().parent().find('.sub-menu').slideToggle();
      e.preventDefault();
    });
  }
  if ($('.gridItem').length > 0) {

  }
  
  if ($('.projectcarousel').length > 0) {
    var slideno = $(this).data('slide');

    $('.projectcarousel').slick({
      dots: false,   
      arrows: true,   
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
      responsive: [
        {
            breakpoint: 700,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
  
            }
        }
      ]
  });

  $('.projectcarousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //console.log(nextSlide);
    $('.slidecount span').html('0'+(nextSlide+1));
  });
     
  
  }
  
  if ($('.kundenContainer').length > 0) {
    
    $('.kundenContainer').slick({
      dots: false,   
      arrows: true,   
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: true,
      responsive: [
        {
            breakpoint: 700,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
  
            }
        }
      ]
  });

  }
  
  
  
 
  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
    $.featherlightGallery.prototype.afterContent = function () {
        var caption = this.$currentTarget.find('.imageBox').attr('title');
        this.$instance.find('.caption').remove();
        $('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
    }
  }
  if ($('.flexslider').length > 0) {
    $('.flexslider').flexslider({
      animation: "fade",
      
      directionNav: true,
      animationLoop: true,
      controlNav: false,
      pauseOnHover: false,
      prevText: "",
      nextText: "",
      start: function(slider){

        $('.flexPagination .end').html('0'+slider.count);
       
      },
      after: function(slider){
       
        $('.flexPagination .position').css('height',270/slider.count+'px');
        $('.flexPagination .position').css('margin-top',((slider.currentSlide) / slider.count)*270);
      }
  });
  }


  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-100
        }, 1000);
        return false;
    }
    }
});

});